/* eslint-disable no-unused-vars */
import httpService from '@/services/httpService'
import _ from 'lodash'
import { convertAdvancedOptionsToURLParams } from '@/store/modules/rank-zone/Helper'
import AttributeReport from '../../../features/reports/attribute/AttributeReport'

export const types = {
  ADD_AGENCY_DATA: 'agency/ADD_AGENCY_DATA',
  ADD_AGENCY: 'agency/ADD_AGENCY',
  ADD_BILLING_DATA: 'agency/ADD_BILLING_DATA',
  SET_PAYMENT_PLANS: 'agency/SET_PAYMENT_PLANS',
  SET_STRIPE_CLIENT_SECRET: 'agency/SET_STRIPE_CLIENT_SECRET',
}
const state = {
  agencies: [],
  billingData: {},
  agencyData: {},
  shouldSelectPaymentPlan: false,
  paymentPlans: [],
  stripeClientSecret: null,
  planName: null,
  orderNumber: null
}

const mutations = {
  [types.ADD_AGENCY_DATA]: function (state, agencyData) {
    state.agencies = agencyData.agencies || []
  },
  [types.ADD_AGENCY]: function (state, agencyData) {
    state.agencyData = agencyData
  },
  [types.ADD_BILLING_DATA]: function (state, billingData) {
    state.billingData = billingData
  },
  [ types.SET_PAYMENT_PLANS ]: function (state, paymentPlans) {
    state.paymentPlans = paymentPlans
  },
  [ types.SET_STRIPE_CLIENT_SECRET ]: function (state, stripeClientSecret) {
    state.stripeClientSecret = stripeClientSecret
  },
}

const actions = {
  updatePlanGroup: async function ({ commit }, selectedPlanId) {
    const data = {
      selected_plan_id: selectedPlanId
    }
    const response = await httpService.patch('agency_dashboard/update-plan-group', data,
      { successMessage: 'Plan group updated', cancelErrorMessage: true, raiseError: true }).then(res => {
      }).catch(errors => {
        return { errors }
      })
      return response
  },
  updateSubscription: async function ({ commit }, selectedProductId) {
    const data = {
      selected_product_id: selectedProductId
    }
    const response = await httpService.patch('stripe/update-subscription', data,
      { successMessage: 'Subscription updated', cancelErrorMessage: true, raiseError: true }).then(res => {
      }).catch(errors => {
        return { errors }
      })
      return response
  },
  updateAgencyData: async function ({ commit }, { clientId, id, name, email }) {
    const data = JSON.stringify({ id, name, email })
    const response = await httpService.patch(`agency_dashboard/${clientId}`, { form: data },
      { successMessage: 'Agency successfully updated', cancelErrorMessage: true, raiseError: true }).then(res => {
      }).catch(errors => {
        return { errors }
      })
      return response
  },
  getAgency: async function ({ commit }, { clientId }) {
    const response = await httpService.get(`agency_dashboard/${clientId}`)
    if (!response || !response.data) {
      return
    }
    commit(types.ADD_AGENCY, response.data.agency)
    commit(types.ADD_BILLING_DATA, response.data.billing)
    return response.data
  },
  getAgencyData: async function ({ commit }) {
    const response = await httpService.get('agency')
    if (!response || !response.data) {
      return
    }
    commit(types.ADD_AGENCY_DATA, response.data)
    return response.data
  },
  createUpdateAgency: async function (storage, { method, successMessage, ...params }) {
    const request = httpService[method]
    const response = await request('agency', params, { cancelErrorMessage: true })
    if (!response || !response.data) {
      return {}
    }
    return response.data
  },
  removeAgency: async function (storage, params) {
    const response = await httpService.delete('agency', { params, successMessage: 'Agency removed successfully' })
    if (!response || !response.data) {
      return {}
    }
    return response.data
  },
  selectPaymentPlan: async function({ commit }, { paymentPlanId, userId }) {
    // TODO: implement this action
    console.log('selectPaymentPlan', paymentPlanId, userId)
    
  },
  getStripeClientSecret: async function({ commit }) {
    try {
      const response = await httpService.get('/stripe/client-secret');
      
      // commit(types.SET_STRIPE_CLIENT_SECRET, response.data?.client_secret || null)
    } catch (error) {
      console.error(error)
    }
  },
  resetStripeClientSecret: function({ commit }) {
    commit(types.SET_STRIPE_CLIENT_SECRET, null)
  },
  getPaymentPlans: async function({ commit }) {
    // TODO: implement this action, remove mocked data
    console.log('getPaymentPlans');
    
      try {
        console.log('getPaymentPlans');
        const response = await httpService.get('/stripe/payment-plans');
        
        if (response && response.data) {
          console.log('response.data', response.data);
          commit(types.SET_PAYMENT_PLANS, response.data);
        } else {
          console.error('Invalid response from payment plans endpoint');
        }
      } catch (error) {
        console.error('Error getting payment plans:', error);
        // Fallback to empty array if API fails
        commit(types.SET_PAYMENT_PLANS, []);
      }
  },
  checkPromoCode: async function(store, { promoCode }) {
    try {
      const response = await httpService.post('/stripe/check-promo-code', { promo_code: promoCode });
      
      if (response.data?.valid) {
        return {
          discount: response.data.discount,
          type: response.data.type,
          promoCode: response.data.promo_code
        };
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error checking promo code:', error);
      return null;
    }
  },
  createSubscription: async function({ commit }, { planId, promoCode, discountAmount }) {
    try {
      const requestData = { 
        plan_id: planId,
        promo_code: promoCode,
        discount_amount: discountAmount
      };
      
      const response = await httpService.post('/stripe/create-subscription', requestData);
      
      if (response.data?.clientSecret) {
        commit(types.SET_STRIPE_CLIENT_SECRET, response.data.clientSecret);
        state.planName = state.paymentPlans.find(plan => plan.id === planId).name;
        state.orderNumber = response.data.invoice_id;
        return {
          type: response.data.type,
          clientSecret: response.data.clientSecret,
          subscriptionId: response.data.subscription_id,
          subscriptionStatus: response.data.subscription_status
        };
      }
      throw new Error('Failed to create subscription');
    } catch (error) {
      console.error('Error creating subscription:', error);
      throw error;
    }
  },
  cancelSubscription: async function () {
    // TODO: Implement cancel subscription API call
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ success: true })
      }, Math.random() * 1000)
    })
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
